export const MEDIA_QUERY_MOBILE = '(max-width: 600px)';
export const MEDIA_QUERY_TABLET = '(max-width: 1023px)';
